var render = function render(){var _vm=this,_c=_vm._self._c;return _c('public-layout',[_c('div',{staticClass:"mx-auto pt-3 content-center lg:px-12 md:w-1/2 xl:w-2/5"},[_c('div',{staticClass:"flex flex-col px-6 py-8 border border-gray-100 shadow-2xl rounded bg-white lg:px-12"},[_c('login-form')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }